import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import DashboardService from "src/apis/DashboardService";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import Channels from "../../../Charts/Channels";

const DashboardChannel = ({ t, filters, modules }) => {
  const { data: dashboardData, isFetching: summaryIsFetching } = useQuery({
    queryKey: ["wb-cm-fetch-admin-dashboard-summary-query", filters],
    queryFn: async () => {
      const service = DashboardService.getInstance();
      return await service.fetchSummary(
        {
          ...filters,
          excludeDeleted: (filters.exclude || []).includes("deleted_cases"),
          excludeTestCases: (filters.exclude || []).includes("test_cases"),
          exclude: undefined,
        },
        modules?.active
      );
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  const channels = useMemo(() => {
    const result = [];
    if (dashboardData?.sources) {
      const sources = dashboardData?.sources;

      for (const item in sources) {
        const title = t(sources[item].title);
        result.push({
          amount: sources[item].amount,
          title: title,
          percent: sources[item].percent,
        });
      }
    }
    return result;
  }, [dashboardData?.sources, t]);

  return <Channels data={channels} isLoading={summaryIsFetching} />
};

export default withNamespaces()(DashboardChannel);
